module.exports = __webpack_public_path__ + "img/DTE_20210506.dfb9a91f.png";